<template>
  <div class="imprint">
    <section class="hero">
      <div class="hero-body">
        <div class="columns is-desktop">
          <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
            <div class="content">
              <router-link to="/">
                <button class="button is-medium is-warning">
                    Back home
                </button>
              </router-link>
              <h1 class="Graphit-Bold introduction"><span v-html="imprint.title"></span>
              </h1>
              <article v-html="imprint.content">
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'Imprint',
  props: {
  },
  computed: {
    ...mapState([
      'imprint',
    ]),
  },
  async mounted() {
    await this.$store.dispatch('UPDATE_IMPRINT');
    VueScrollTo.scrollTo('#app');
  },
};
</script>
